import * as XLSX from 'xlsx';

export function readExcelFile(file, columnName) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const columnData = await getColumnData(worksheet);

            const particularColumnData = await getParticularColumnData(columnData, columnName);
            
            resolve(particularColumnData);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsArrayBuffer(file);
    });
}

function getColumnData(worksheet) {

    const columnData = {};
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    for (let C = range.s.c; C <= range.e.c; ++C) {
        const column = XLSX.utils.encode_col(C);
        const columnValues = [];
        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cellAddress = { c: C, r: R };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            const cell = worksheet[cellRef];
            columnValues.push(cell ? cell.v : undefined);
        }
        columnData[column] = columnValues;
    }

    return columnData;

}

function getParticularColumnData(columnData, columnName) {
    for (const column in columnData) {
        const hasColumnData = columnData[column].some(element => {
            return typeof element === 'string' && element.toLowerCase().includes(columnName);
        });

        console.log("hasColumnData ::", hasColumnData);

        if (hasColumnData) {
            return columnData[column];
        }
    }
    return null;
};